import { Calculator, Percent, Sigma, Wallet } from "lucide-react";

const items = [
  {
    icon: Sigma,
    title: "American Odds",
    body: "A positive number (like +150) shows the profit on a $100 bet. A negative number (like -110) shows how much you must wager to win $100. American odds never sit between -100 and +100.",
  },
  {
    icon: Percent,
    title: "Decimal Odds",
    body: "A single multiplier that includes your stake. Multiply your bet by the decimal to get your total payout — for example, $10 at 2.50 returns $25.00.",
  },
  {
    icon: Calculator,
    title: "Fractional Odds",
    body: "Written as a ratio (like 10/11 or 3/2) showing profit relative to stake. 10/11 means you profit $10 for every $11 wagered; 3/2 means $3 profit for every $2 wagered.",
  },
  {
    icon: Wallet,
    title: "Parlay Payouts",
    body: "Convert each leg to decimal odds, multiply them together to get the combined decimal, then multiply by your stake for the total payout. Missing any leg voids the parlay.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="mt-16 md:mt-24">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <p className="font-display text-emerald-400 text-xs tracking-[0.25em] uppercase">
            The Basics
          </p>
          <h2 className="mt-2 font-display text-white text-3xl md:text-4xl uppercase tracking-tight">
            How It Works
          </h2>
          <p className="mt-3 text-slate-300 text-sm md:text-base">
            Short primers on the numbers behind every bet. Skim the ones you need — the tools
            above handle the math for you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <article
                key={it.title}
                className="pa-card-dark p-6 flex gap-4"
              >
                <div
                  aria-hidden="true"
                  className="shrink-0 w-11 h-11 rounded-xl inline-flex items-center justify-center"
                  style={{
                    background: "rgba(16,185,129,0.14)",
                    color: "#6ee7b7",
                    border: "1px solid rgba(16,185,129,0.3)",
                  }}
                >
                  <Icon size={20} />
                </div>
                <div>
                  <h3 className="font-display text-white text-lg uppercase tracking-wide">
                    {it.title}
                  </h3>
                  <p className="mt-1.5 text-slate-300 text-sm leading-relaxed">
                    {it.body}
                  </p>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 pa-card-dark p-6">
          <h3 className="font-display text-white text-lg uppercase tracking-wide">
            Profit vs. Total Payout
          </h3>
          <p className="mt-1.5 text-slate-300 text-sm leading-relaxed">
            <span className="text-white font-semibold">Total payout</span> is everything the
            sportsbook returns — your original stake plus your winnings.
            <span className="text-white font-semibold"> Potential profit</span> is only the
            winnings: total payout minus the amount you wagered.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
